export const GET_THREAD_DETAILS_START = 'GET_THREAD_DETAILS_START'
export const GET_THREAD_DETAILS_SUCCESS = 'GET_THREAD_DETAILS_SUCCESS'
export const GET_THREAD_DETAILS_FAIL = 'GET_THREAD_DETAILS_FAIL'

export const GET_DEALERSHIP_DETAILS_START = 'GET_DEALERSHIP_DETAILS_START'
export const GET_DEALERSHIP_DETAILS_SUCCESS = 'GET_DEALERSHIP_DETAILS_SUCCESS'
export const GET_DEALERSHIP_DETAILS_FAIL = 'GET_DEALERSHIP_DETAILS_FAIL'

export const UPDATE_ANSWER_MODE_START = 'UPDATE_ANSWER_MODE_START'
export const UPDATE_ANSWER_MODE_SUCCESS = 'UPDATE_ANSWER_MODE_SUCCESS'
export const UPDATE_ANSWER_MODE_FAIL = 'UPDATE_ANSWER_MODE_FAIL'

export const GET_USER_DETAILS_START = 'GET_USER_DETAILS_START'
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS'
export const GET_USER_DETAILS_FAIL = 'GET_USER_DETAILS_FAIL'

export const UPDATE_SUBSCRIPTION_START = 'UPDATE_SUBSCRIPTION_START'
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS'
export const UPDATE_SUBSCRIPTION_FAIL = 'UPDATE_SUBSCRIPTION_FAIL'

export const UPDATE_INTEREST_STATUS_START = 'UPDATE_INTEREST_STATUS_START'
export const UPDATE_INTEREST_STATUS_SUCCESS = 'UPDATE_INTEREST_STATUS_SUCCESS'
export const UPDATE_INTEREST_STATUS_FAIL = 'UPDATE_INTEREST_STATUS_FAIL'

export const GET_ELEAD_URL_START = 'GET_ELEAD_URL_START'
export const GET_ELEAD_URL_SUCCESS = 'GET_ELEAD_URL_SUCCESS'
export const GET_ELEAD_URL_FAIL = 'GET_ELEAD_URL_FAIL'

export const GENERATE_ANSWER_START = 'GENERATE_ANSWER_START'
export const GENERATE_ANSWER_SUCCESS = 'GENERATE_ANSWER_SUCCESS'
export const GENERATE_ANSWER_FAIL = 'GENERATE_ANSWER_FAIL'

export const GET_USER_SUBSCRIPTION_START = 'GET_USER_SUBSCRIPTION_START'
export const GET_USER_SUBSCRIPTION_SUCCESS = 'GET_USER_SUBSCRIPTION_SUCCESS'
export const GET_USER_SUBSCRIPTION_FAIL = 'GET_USER_SUBSCRIPTION_FAIL'
